import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#417a2a', // Verde principale richiesto
    },
    background: {
      default: '#f5f5f7', // Grigio chiaro per lo sfondo
    },
  },
  typography: {
    // Applica Titillium Web come font principale
    fontFamily: '"Titillium Web", "Roboto", "Helvetica", "Arial", sans-serif',

    // Riduciamo le dimensioni dei titoli per un look più equilibrato
    h4: {
      fontSize: '1.8rem', // Era ~2.1rem
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.4rem', // Era ~1.5rem
      fontWeight: 600,
    },
  },
  components: {
    // Applichiamo uno stile morbido a tutti i bottoni e le card
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '20px', // Bordi molto arrotondati
          textTransform: 'none', // Testo non in maiuscolo
          boxShadow: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '16px', // Bordi arrotondati stile Apple
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)', // Ombra delicata
        },
      },
    },
  },
});

export default theme;